import { RemoveRedEye } from "@mui/icons-material";
import { Typography } from "@mui/material";
import moment from "moment";
import { useState } from "react";
import { useSelector } from "react-redux";
import DropZone from "../../commons/dropZone/DropZone";
import DataLabel from "../../commons/labels/DataLabel";
import { StyledComprobante } from "../../styled/Reintegros";
import ComprobanteDetail from "./ComprobanteDetail";

const ComprobanteContainer = ({ fromBread, handleSubmit }) => {

  const siniestro = useSelector((state) => state.reintegros.localSiniestro);
  const postReintegro = useSelector((state) => state.reintegros.postReintegro);
  const sendReintegros = useSelector(
    (state) => state.reintegros.sendReintegros
  );

  const [comprobanteFile, setComprobanteFile] = useState(null);
  const [openDetail, setOpenDetail] = useState(false);

  return (
    <StyledComprobante.Container>
      <div>
        <Typography variant="h6">Adjuntar comprobante</Typography>
      </div>
      <StyledComprobante.DataContainer>
        <DataLabel
          firstText={"Siniestro: " + siniestro.numeroSiniestroART}
          secondText={"DNI: " + siniestro.numeroDocumento}
          thirdText={siniestro.apellidoNombres}
        />
        <DataLabel
          firstText={
            postReintegro.beneficiario.nombre_trabajador.split("/")[0] ||
            postReintegro.beneficiario.nombre_empleadores.split("/")[0]
          }
          secondText={
            postReintegro.beneficiario.nombre_trabajador.split("/")[1] ||
            postReintegro.beneficiario.nombre_empleadores.split("/")[1]
          }
          thirdText={"CBU: " + postReintegro.beneficiario.cbu}
        />
        <DataLabel
          firstText={moment(
            postReintegro.datosComprobante.data.fechaDelComprobante
          ).format("DD/MM/YYYY")}
          secondText={
            postReintegro.datosComprobante.data.tipo +
            ": " +
            postReintegro.datosComprobante.data.letra +
            " " +
            postReintegro.datosComprobante.data.ptoVenta +
            " - " +
            postReintegro.datosComprobante.data.nro
          }
          thirdText={
            "$" +
            postReintegro.comprobantes.total.toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })
          }
          icon={
            <RemoveRedEye
              style={{ cursor: "pointer", marginLeft: 10 }}
              onClick={() => setOpenDetail(true)}
            />
          }
        />
      </StyledComprobante.DataContainer>
      <div>
        <div style={{ paddingBottom: "20px" }}>
          <DropZone
            maxFiles={1}
            file={comprobanteFile}
            setFile={setComprobanteFile}
            extension=".jpg, .png, .pdf"
            accept={{
              "image/jpeg": [".jpg"],
              "image/png": [".png"],
              "application/pdf": [".pdf"],
            }}
            required={"Es obligatorio ingresar al menos un comprobante"}
            onUpload={() => handleSubmit(comprobanteFile)}
            dropZoneText="Arrastre aquí o haga click en el recuadro para importar los comprobantes en formato jpg, png o pdf."
            dropZoneEditText="Si desea cambiar el archivo arrástrelo nuevamente o haga click en el recuadro."
            loading={sendReintegros.loading}
            showButtonsAlways
          />
        </div>
      </div>
      <div>
        <ComprobanteDetail
          open={openDetail}
          handleCloseDetail={() => setOpenDetail(false)}
        />
      </div>
    </StyledComprobante.Container>
  );
};

export default ComprobanteContainer;
